import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {config} from "./config";

class ComparisonGraph extends React.Component {
  render() {
    let d = this.props.graphData.map(g => {
      var rObj = {};
      rObj["name"] = g.title;
      rObj["data"] = Object.entries(g.years).map(o => [o[0], o[1].sum]);
      return rObj;
    });
    let dataValues = d[0].data.map(d => d[1]);

    const options = {
      chart: {
        type: 'column',
        style: {
          fontFamily: config.css.defaultFontFamily,
          fontSize: "1.5rem",
          color: "#000000"
        },
        spacingBottom: this.props.compact ? 0: 25,
        spacingTop: this.props.compact ? 0: 25,
        spacingLeft: this.props.compact ? 0: 25,
        spacingRight: this.props.compact ? 0: 25,
        marginTop: this.props.compact ? 30: 65,
        marginRight: this.props.compact ? 5 : 30,
      },
      colors: ['#00584D', '#00AF43', '#00A1E0'],
      credits: {
        enabled: false
      },
      legend: {
        enabled: !this.props.compact,
        symbolRadius: 0,
        align: 'left'
      },
      tooltip: {
        formatter: function () {
            return this.point.name + '<br>' +
              this.series.name + ': <b>' + this.y.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ") + ' €</b>';
        }
      },
      plotOptions: {
        column: {
          maxPointWidth: this.props.compact ? 24 : 10,
        },
      },
      title: {
        text: this.props.compact ? '' : 'Vuosikustannukset',
        align: 'left',
        style: {
          fontFamily: config.css.defaultFontFamily,
          fontSize: '18px',
          fontWeight: config.css.fontWeightHeading
        }
      },
      yAxis: {
        labels: {
          style: {
            fontFamily: config.css.defaultFontFamily,
            fontSize: '11px',
            color: "#000000"
          },
          formatter: function() {
            if (dataValues.some(e => e > 1E9)) {
              return (this.value / 1000000000) + 'mrd';
            } else if (dataValues.some(e => e > 1E6)) {
              return (this.value / 1000000) + 'M';
            }
            return this.value / 1000 + 't';
          },
        },
        title: {
          align: 'high',
          text: 'Euroa',
          style: {
            fontFamily: config.css.defaultFontFamily,
            fontSize: '14px',
            color: '#000000'
          },
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontFamily: config.css.defaultFontFamily,
            fontSize: '11px',
            color: '#000000'
          },
        },
      },
      series: d
    }

    return (
      <HighchartsReact highcharts={Highcharts} options={options} />
    );
  }
}

export default ComparisonGraph;
